var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message - Bold 24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5866 4C24.3746 4 26.0946 4.70667 27.36 5.97467C28.6266 7.24 29.3346 8.94667 29.3346 10.7333V21.2667C29.3346 24.9867 26.308 28 22.5866 28H9.41464C5.6933 28 2.66797 24.9867 2.66797 21.2667V10.7333C2.66797 7.01333 5.67997 4 9.41464 4H22.5866ZM24.708 12.72L24.8146 12.6133C25.1333 12.2267 25.1333 11.6667 24.8 11.28C24.6146 11.0813 24.36 10.96 24.0946 10.9333C23.8146 10.9187 23.548 11.0133 23.3466 11.2L17.3346 16C16.5613 16.6413 15.4533 16.6413 14.668 16L8.66797 11.2C8.2533 10.8933 7.67997 10.9333 7.33464 11.2933C6.97464 11.6533 6.93464 12.2267 7.23997 12.6267L7.41464 12.8L13.4813 17.5333C14.228 18.12 15.1333 18.44 16.0813 18.44C17.0266 18.44 17.948 18.12 18.6933 17.5333L24.708 12.72Z",
    fill: "#21E786"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email-2.13ef6977ba156dd1b0d14ff6e3893573.svg";
export { ForwardRef as ReactComponent };